import { useTranslation } from "react-i18next";
import Breadcrumb from "../../../utils/breadCrumbs";
import PATHS from "../../../../constants/paths";
import { useNavigate } from "react-router-dom";
import {
  ContainerBB,
  TitleBB,
  TitleJunction,
  ButtonRemove,
} from "./reworkProductDetail.styled";
import { getDateFormatTimeZone } from "../../../../utils/formats";
import { REWORK_PROCESS_CLOSED } from "../../../../constants";

const ReworkProductView = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data, readBB, finish, removeItem, onDelete, goBack } = props;
  let sumIn = 0;
  let sumOut = 0;
  if (data) {
    if (data?.in && data?.in.length > 0) {
      for (const dataIn of data?.in) {
        sumIn += dataIn.weight;
      }
    }
    if (data?.out && data?.out.length > 0) {
      for (const dataOut of data?.out) {
        sumOut += dataOut.weight;
      }
    }
  }

  const breads = [
    { label: t("home"), path: PATHS.HOME },
    { label: t("forms.reworkProduct.title"), path: PATHS.REWORK_PRODUCT_LIST },
    { label: t("forms.reworkProduct.detailTitle") },
  ];

  const renderBB = (bbs, isInput = true) => {
    if (bbs && bbs.length > 0) {
      return bbs.map((bb) => {

        return (
          <div className="row mb-1" key={bb.batch}>
            <div className="col-4">{bb.batch}</div>
            <div className="col-4 text-center">{`${bb.itemCode} (${bb.variety})`}</div>
            <div className="col-2 text-end">{`${bb.weight}Kg`}</div>
            <div className="col-2 text-end">
              {isInput && (
                <>
                  {data?.status !== REWORK_PROCESS_CLOSED.code && (
                    <ButtonRemove type="button" onClick={() => removeItem(bb)}>
                      <i className="fa-solid fa-trash-can"></i>
                    </ButtonRemove>
                  )}
                </>
              )}
            </div>
          </div>
        );
      });
    } else {
      return (
        <div className="row">
          <div className="col-12 text-center">
            {t("forms.reworkProduct.noBb")}
          </div>
        </div>
      );
    }
  };
  return (
    <>
      <div className="row justify-content-center mt-4 mt-md-5">
        <div className="col-12 col-md-11">
          <h3 className="title">{t(`forms.reworkProduct.detailTitle`)}</h3>
        </div>
      </div>
      <Breadcrumb items={breads} />

      <>
        <div className="row justify-content-center mt-4">
          <TitleJunction className="col-12 col-md-11 d-flex justify-content-between">
            <div>
              {data?.dateInit ? (
                <span>
                  {`${t("forms.reworkProduct.Open")} (${getDateFormatTimeZone(
                    data?.dateInit,
                    "DD-MM-yyyy HH:mm",
                  )})`}
                </span>
              ) : (
                <span>
                  {`${t("forms.reworkProduct.Created")} (${getDateFormatTimeZone(
                    data?.createdAt,
                    "DD-MM-yyyy HH:mm",
                  )})`}
                </span>
              )}

              {data?.dateEnd ? (
                <span className="ml-2">
                  {" - "}
                  {`${t("forms.reworkProduct.Closed")} (${getDateFormatTimeZone(
                    data?.dateEnd,
                    "DD-MM-yyyy HH:mm",
                  )})`}
                </span>
              ) : null}
            </div>

            {data?.status !== REWORK_PROCESS_CLOSED.code ? (
              <div className="d-flex justify-content-end gap-2">
                <button
                  type="button"
                  className="btn btn-md btn-danger text"
                  onClick={() => onDelete(data?.uuid, sumIn, sumOut)}
                >
                  {t("forms.reworkProduct.buttons.delete")}
                </button>
                <button
                  type="button"
                  className="btn btn-md btn-secondary"
                  onClick={() => finish(sumIn, sumOut, data?.uuid)}
                >
                  {t("forms.reworkProduct.buttons.Finish")}
                </button>
              </div>
            ) : (
              ""
            )}
          </TitleJunction>
        </div>

        {/* NO TOCAR */}
        <div className="row justify-content-center mt-2">
          <div className="col-12 col-md-11">
            <div className="row">
              <div className="col-6">
                <div className="row">
                  <TitleBB className="col-12 d-flex justify-content-between">
                    <div>{t("forms.junction.bbIn")}</div>
                    <div>{`Total: ${sumIn}Kg`}</div>
                  </TitleBB>
                </div>
                <div className="row">
                  <div className="col-12">
                    <ContainerBB>{renderBB(data?.in)}</ContainerBB>
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div className="row">
                  <TitleBB className="col-12 d-flex justify-content-between">
                    <div>{t("forms.junction.bbOut")}</div>
                    <div>{`Total: ${sumOut}Kg`}</div>
                  </TitleBB>
                </div>
                <div className="row">
                  <div className="col-12">
                    <ContainerBB>{renderBB(data?.out, false)}</ContainerBB>
                  </div>
                </div>
              </div>
            </div>
            {data?.status !== REWORK_PROCESS_CLOSED.code ? (
              <div className="row">
                <div className="col-6 text-center">
                  <button
                    type="button"
                    className="btn btn-lg btn-primary mt-5"
                    onClick={() => readBB(false, "IN")}
                  >
                    {t("forms.junction.buttons.in")}
                  </button>
                </div>
                <div className="col-6 text-center">
                  <button
                    type="button"
                    className="btn btn-lg btn-primary mt-5"
                    onClick={() => readBB(false, "OUT")}
                  >
                    {t("forms.junction.buttons.out")}
                  </button>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="row justify-content-center mt-5 mb-5">
            <div className="col-12 col-md-11 d-flex justify-content-center">
              <button
                className="btn btn-secondary btn-lg me-3"
                onClick={() => goBack()}
              >
                {t("forms.reworkProduct.buttons.backReworkProductList")}
              </button>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

ReworkProductView.propTypes = {
  // handleSubmit: PropTypes.func,
  // initialValues: PropTypes.object,
};

export default ReworkProductView;
